import React, { CSSProperties } from 'react';

interface ExteriorFeaturesProps {
  detailListStyle: CSSProperties,
  fencing: Array<string> | undefined,
  exteriorFeatures: Array<string> | undefined,
  poolPrivateYN: boolean | undefined,
  poolFeatures: Array<string> | undefined,
}

const ExteriorFeatures = ({detailListStyle, fencing, exteriorFeatures, poolPrivateYN, poolFeatures} : ExteriorFeaturesProps) => {
	const fl: any = [];
	fencing?.map((fence: string) => {
		return fl.push(fence);
	});
	const fString = fl.join(', ');

	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-flower-tulip me-2" />
        Exterior Features
			</p>
			<ul style={detailListStyle}>
				{exteriorFeatures ? (exteriorFeatures.map((ef: string, i: number) => {
					return <li key={i}>{ef}</li>;
				})) : ''}
                
				{fencing ? <li><span className="cc-font-weight--normal">Fencing:</span> {fString}</li> : null}
      
				{poolPrivateYN ? (
					<li>
						<span className="cc-font-weight--normal">Private Pool:</span> Yes
						{poolFeatures
							? poolFeatures.map((pf: string) => {
								return ', ' + pf;
							})
							: null}
					</li>
				) : null}

				{ (!exteriorFeatures && !fencing && !poolPrivateYN) ?
					<li>None listed</li>
					: ''
				}
			</ul>
		</React.Fragment>
	);
};

export default ExteriorFeatures;